<template>
  <div class="display-description-wrapper">
    <div class="spotDetailBtn">
      <div
        v-for="(item, index) in tabs"
        :key="item.id"
        @click="changeTab(index)"
        :class="[active === index ? 'activeTab' : '']"
      >
        <img :src="item.activeIcon" alt="" v-if="active === index" />
        <img :src="item.icon" alt="" v-else />
        <span>{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import buyMo from '@/assets/img/ticket_b.png';
import buyCo from '@/assets/img/ticket_c.png';
import msgMo from '@/assets/img/msg_b.png';
import msgCo from '@/assets/img/msg_c.png';
import descMo from '@/assets/img/spot_b.png';
import descCo from '@/assets/img/spot_c.png';
import venMo from '@/assets/img/venue_b.png';
import venCo from '@/assets/img/venue_c.png';

export default {
  props: {
    type: [String],
  },
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    tabs() {
      if (this.type) {
        return [
          { id: 0, title: '预约购票', icon: buyMo, activeIcon: buyCo },
          { id: 1, title: '场馆介绍', icon: venMo, activeIcon: venCo },
          { id: 2, title: '购票须知', icon: msgMo, activeIcon: msgCo },
        ];
      }
      return [
        { id: 0, title: '预约购票', icon: buyMo, activeIcon: buyCo },
        { id: 1, title: '景区介绍', icon: descMo, activeIcon: descCo },
        { id: 2, title: '购票须知', icon: msgMo, activeIcon: msgCo },
      ];
    },
  },
  methods: {
    changeTab(index) {
      this.active = index;
      this.$emit('getActiveTab', index);
    },
  },
};
</script>
<style lang="less" scoped>
.display-description-wrapper {
  .spotDetailBtn {
    position: relative;
    top: -10px;
    left: 50%;
    margin-left: -38%;
    height: 60px;
    width: 76%;
    border: 1px solid #45b97c;
    box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.2);
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    & > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      img {
        width: 36px;
        height: 36px;
      }
      span {
        margin-top: 2px;
        margin-bottom: 4px;
      }
      // /deep/ .van-icon {
      //   font-size: 24px;
      //   margin-bottom: 4px;
      // }
    }
    // .activeTab {
    //   color: #45b97c;
    // }
  }
  /deep/ .van-popup--bottom {
    .contBox {
      .cont {
        padding: 10px;
      }
    }
  }
}
</style>
